import cn from 'classnames';
import T from 'prop-types';
import React from 'react';
import { Nav, Navbar } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import NavProjectSelect from '../../../../../components/select/jobSelect/NavProjectSelect';
import useProjectsList from '../../../../../hooks/useProjectsList';
import { profileSelectors } from '../../../../../redux/selectors/profile';
import routes from '../../../../../routes/constants';
import text from '../../../../../text';
import ShareLinkNav from './ShareLinkNav';
var FileManagerNav = function(param) {
    var className = param.className, showShareLink = param.showShareLink;
    var history = useHistory();
    var isAdmin = useSelector(profileSelectors.getIsAdmin);
    var _useProjectsList = useProjectsList({
        isAdmin: isAdmin
    }), projects = _useProjectsList.projects, isLoading = _useProjectsList.isLoading;
    return /*#__PURE__*/ React.createElement(Nav, {
        className: cn('Title', className)
    }, /*#__PURE__*/ React.createElement(Navbar, null, /*#__PURE__*/ React.createElement("span", null, "".concat(text(isAdmin ? 'administrationFileManager' : 'fileManager'), ":")), /*#__PURE__*/ React.createElement(NavProjectSelect, {
        projects: projects,
        isLoading: isLoading,
        onProjectChange: function(nextProject, prevProject) {
            if (nextProject.id !== prevProject.id) {
                history.replace(routes.fileManager.viewProject(nextProject.id));
            }
        }
    }), /*#__PURE__*/ React.createElement(ShareLinkNav, {
        show: showShareLink
    })));
};
FileManagerNav.propTypes = {
    className: T.string
};
export default FileManagerNav;
